export default "__VITE_ASSET__6jN$ev6L__ 1040w, __VITE_ASSET__0bGIMZNd__ 767w, __VITE_ASSET__K3HC4WNY__ 500w";